document.addEventListener('DOMContentLoaded', function () {
  const selector = '#featuredProducts-SECTION_ID';

  if (typeof window.jQuery === 'undefined' || typeof jQuery.fn.slick !== 'function') return;
  if (!document.querySelector(selector)) return;

  const $slider = jQuery(selector);

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          lazyLoad: 'ondemand',
          cssEase: 'linear'
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          lazyLoad: 'ondemand',
          cssEase: 'linear'
        }
      }
    ]
  });

  // Scroll current product into view
  const activeSlide = document.querySelector(selector + ' .ftrp--product-block.is-selected');
  if (activeSlide) {
    const slickSlide = activeSlide.closest('.slick-slide');
    if (slickSlide && slickSlide.dataset.slickIndex !== undefined) {
      $slider.slick('slickGoTo', Number(slickSlide.dataset.slickIndex));
    }
  }
});